// This must only be used on the client side, so only call this function inside useEffect().
// This is because the function uses Math.random() which produce different result on the server and client, causing HTML mismatch error.
const getRandom = (items: string[]) => {
  const randomIndex = Math.floor(Math.random() * items.length);
  return items[randomIndex];
};

export default getRandom;
